import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Card({ className, ...props }: ComponentProps<'section'>) {
  return (
    <section className={cn('rounded-lg border border-border bg-surface shadow-card', className)} {...props} />
  )
}

interface CardHeaderProps {
  title: ReactNode
  description?: ReactNode
  eyebrow?: string
  actions?: ReactNode
  className?: string
}

export function CardHeader({ title, description, eyebrow, actions, className }: CardHeaderProps) {
  return (
    <header className={cn('flex flex-wrap items-start justify-between gap-3 px-5 pt-5 pb-4', className)}>
      <div className="grid min-w-0 gap-1">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h2 className="text-[15px] font-semibold text-ink">{title}</h2>
        {description && <p className="max-w-prose text-[13px] text-ink-muted">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  )
}

export function CardBody({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('px-5 pb-5', className)} {...props} />
}
